import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardWrapper, CardHeader, CardSection } from 'foundations-components/transitional/components/Card';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { PreviewImage } from 'content-management-details-lib/components/ContentPreviewImage';
import MABChart from './MABChart';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MabWinnerUrlPreviewScreenshot = ({
  mabWinner
}) => {
  return /*#__PURE__*/_jsx("div", {
    style: {
      width: 300
    },
    children: /*#__PURE__*/_jsx(PreviewImage, {
      name: mabWinner.name,
      previewUrl: mabWinner.url,
      screenshotUrl: mabWinner.screenshotPreviewUrl,
      screenshotUrlLoading: false
    })
  });
};
const CardTitle = ({
  mabVariantsMap,
  mabMetric,
  winners
}) => {
  const winnerNames = winners.map(variant => `"${variant.name}"`);
  const variantsCount = Object.keys(mabVariantsMap).length;
  const winnersCount = winnerNames.length;
  if (winnersCount === 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.testResults.personalization.mabMetricCard.header"
    });
  }
  const allTied = variantsCount === winnersCount;
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: allTied ? `page-details-ui.testResults.personalization.mabMetricCard.winnerHeader.${mabMetric}.allTied` : `page-details-ui.testResults.personalization.mabMetricCard.winnerHeader.${mabMetric}.notAllTied`,
    options: {
      count: winnersCount,
      variantNames: I18n.formatList(winnerNames)
    }
  });
};
const MABMetricCard = ({
  dateRange,
  mabMetric,
  mabVariantsMap,
  onMABReportMetricsChange,
  onNoData,
  variantIds
}) => {
  const [winners, setWinners] = useState([]);
  return /*#__PURE__*/_jsxs(CardWrapper, {
    "data-test-id": "mab-metric-card",
    children: [/*#__PURE__*/_jsx(CardHeader, {
      title: /*#__PURE__*/_jsx(CardTitle, {
        winners: winners,
        mabVariantsMap: mabVariantsMap,
        mabMetric: mabMetric
      }),
      titleSize: "large"
    }), /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsx(MediaObject, {
        align: "center",
        itemLeft: winners.length > 0 ? /*#__PURE__*/_jsx(MabWinnerUrlPreviewScreenshot, {
          mabWinner: winners[0]
        }) : null,
        spacing: "large",
        children: /*#__PURE__*/_jsx(MABChart, {
          dateRange: dateRange,
          mabMetric: mabMetric,
          onMABReportMetricsChange: onMABReportMetricsChange,
          onNoData: onNoData,
          onWinnersChange: winnerIds => {
            setWinners(winnerIds.map(id => mabVariantsMap[parseInt(id, 10)]));
          },
          variantIds: variantIds
        })
      })
    })]
  });
};
export default MABMetricCard;